import { Trans } from '@lingui/react/macro';
import { BookmarkActionViewMode, Folder } from '../../types/api';
import MenuItem from './MenuItem';
import Icon from '../ui/Icon';

interface FolderMenuProps {
  folders: Folder[];
  currentFolderId?: string;
  viewMode?: BookmarkActionViewMode;
  onSelect: (folderId: string) => void;
  onBack: () => void;
}

function FolderMenu({
  folders,
  currentFolderId,
  viewMode = 'home',
  onSelect,
  onBack,
}: FolderMenuProps) {
  // Don't filter out current folder - show it with checkmark

  return (
    <div className="w-[200px] overflow-hidden">
      <div className="py-2">
        {/* Back button */}
        <MenuItem onClick={onBack} icon={<Icon name="arrow-left" />}>
          <Trans>Back</Trans>
        </MenuItem>
        <div className="menu-divider" />
        <div className="max-h-[300px] overflow-y-auto">
          {/* Home option - show when not already in home view */}
          {viewMode !== 'home' && (
            <MenuItem onClick={() => onSelect('home')} icon={<Icon name="home" />}>
              <Trans>Home</Trans>
            </MenuItem>
          )}

          {/* Folder options */}
          {folders.map((folder) => {
            const isCurrentFolder = folder.id === currentFolderId;
            return (
              <MenuItem
                key={folder.id}
                onClick={() => !isCurrentFolder && onSelect(folder.id)}
                disabled={isCurrentFolder}
                icon={
                  isCurrentFolder ? (
                    <Icon name="checkmark" className="text-success" />
                  ) : (
                    <Icon name="folder" />
                  )
                }
                className={isCurrentFolder ? 'cursor-default' : ''}
              >
                <span className="truncate">{folder.displayTitle}</span>
              </MenuItem>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default FolderMenu;
